import { PostSection } from "@/components/blog/PostSection";

export function OptimizacionTecnicaSection() {
  return (
    <PostSection id="optimizacion-tecnica-ux" title="Optimización técnica y experiencia de usuario">
      <p>
        Con tantos formatos nuevos de búsqueda y con la potencia de la IA, la estructura técnica del sitio 
        vuelve a cobrar protagonismo. No se trata solo de «cargar rápido»: se trata de que la web 
        <strong> se sienta fluida</strong>.
      </p>

      <h3 id="core-web-vitals" className="text-xl font-bold text-white mt-8 mb-4">
        Core Web Vitals y rendimiento real
      </h3>
      <p>
        En 2026, Google da más peso a la <strong>interactividad real</strong> (INP — Interaction to Next Paint) 
        que a métricas teóricas. Lo que importa:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>INP (Interaction to Next Paint):</strong> ¿responde tu web rápido cuando el usuario toca un botón?</li>
        <li><strong>LCP (Largest Contentful Paint):</strong> ¿carga el contenido principal en menos de 2.5 segundos?</li>
        <li><strong>CLS (Cumulative Layout Shift):</strong> ¿se mueve el contenido mientras carga?</li>
      </ul>
      <p className="mt-4">
        No hace falta obsesionarse con puntuaciones perfectas. Lo que importa es que el usuario sienta que 
        la web funciona: <strong>menús que responden, botones que reaccionan, formularios que no se traban</strong>.
      </p>

      <h3 id="mobile-first" className="text-xl font-bold text-white mt-8 mb-4">
        Mobile-first y accesibilidad
      </h3>
      <p>
        Más del 60% de las búsquedas se hacen desde móvil. Si tu web es lenta o desordenada en móvil, 
        pierdes tanto en rankings como en conversiones. Las claves:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li>Diseño responsive que priorice la experiencia móvil</li>
        <li>Navegación táctil clara con botones de tamaño adecuado</li>
        <li>Textos legibles sin necesidad de hacer zoom</li>
        <li>Accesibilidad web (WCAG): contraste, semántica HTML, navegación por teclado</li>
      </ul>
    </PostSection>
  );
}
